<template>
  <v-app>
    <v-main>
      <v-container class="mt-0">
        <v-row class="d-flex justify-center">
          <v-col lg="4" md="6" sm="8" cols="10">
            <v-img
              alt="DSDA Logo"
              class="shrink mx-auto"
              contain
              src="../assets/icon.png"
              transition="scale-transition"
              height="100px"
            />
            <v-card color="primary" dark class="mt-2">
              <v-card-title >
              </v-card-title>
              <v-card-text>
                <v-row class="text-center">
                  <v-col class="mb-n4">
                    <h1 style="color:white">Log-In Petugas</h1>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                   <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                  >
                    <v-select
                      v-model="location"
                      :items="locations"
                      :rules="locationRules"
                      label="UPTD PSDA"
                      prepend-icon="mdi-map"
                      required
                      @change="getStations(location,jenis)"
                    ></v-select>
                    <v-select
                      v-model="jenis"
                      :items="['PCH','TMA']"
                      :rules="jenisRules"
                      label="Jenis Alat"
                      prepend-icon="mdi-memory"
                      required
                      @change="getStations(location,jenis)"
                    ></v-select>
                    <v-select
                      v-model="station"
                      :items="stations"
                      :rules="stationRules"
                      label="Station"
                      prepend-icon="mdi-memory"
                      required
                    ></v-select>
                    <v-text-field
                      v-model="password"
                      :rules="passwordRules"
                      label="Password"
                      :type="show1 ? 'text' : 'password'"
                      prepend-icon="mdi-lock"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show1 = !show1"
                      required
                    ></v-text-field>
                    <h4 style="color:#ff5252">{{errorServer}}</h4>
                    <br>
                    <v-row>
                    <v-col>
                      <v-btn
                        color="warning"
                        class="float-end"
                        @click="LogIn(station,password,jenis)"
                      >
                        Log In
                      </v-btn>
                    </v-col>
                    </v-row>
                  </v-form> 
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center">
          <v-col>
            <v-card flat class="my-4">
              <v-row no-gutters class="text-center">
                <v-col>
                  <v-img
                    alt="Dinas Logo"
                    class="shrink float-left"
                    contain
                    src="@/assets/provinsi.png"
                    transition="scale-transition"
                    width="70"
                  />
                  <div class="text-caption">DINAS SUMBER DAYA AIR PROVINSI JAWA BARAT</div>  
                  <div class="text-caption">Jl.Braga No.137, Babakan Ciamis, Kec. Sumur Bandung,</div>
                  <div class="text-caption">Kota Bandung, Jawa Barat 40111 (022) 4236113</div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import firebase from "firebase/app"
import 'firebase/auth'
import { db }from "../firebase/db.js"
import axios from "axios"

  export default {
    name: 'LogIn',

    data: () => ({
      station:'',
      show1:false,
      location:'',
      password:'',
      jenis:null,
      errorServer:'',
      valid: true,
      jenisRules: [
        v => !!v || 'Jenis Alat is required',
      ],
      stationRules: [
        v => !!v || 'Station is required',
      ],
      locationRules: [
        v => !!v || 'Location is required',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >=8) || 'Password must be at least 8 characters'
      ],
      locations:['WS CIMANUK - CISANGGARUNG', 'WS CITANDUY', 'WS CIWULAN - CILAKI','WS CISADEA - CIBARENO','WS CITARUM', 'WS CILIWUNG - CISADANE'],
      stations:[],
    }),
    mounted () {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          //Signed In
          if (localStorage.getItem("role")=='Petugas') {
            this.station=localStorage.getItem("device");
            this.$router.push(`/MapPetugas-id=${this.station}&device=${this.jenis}`)
          }
        } 
      });
    },
    methods: {
      LogIn (macAddress,password,jenis) {
        console.log(macAddress)
         if (this.$refs.form.validate()) {
          let index = this.stations.findIndex(x => x.value==macAddress)
          let station= this.stations[index].text
          let loader = this.$loading.show()
          let url = 'https://us-central1-rainmonitor-b0968.cloudfunctions.net/Rain/login'
          if (jenis!=='PCH')
          {
            url='https://us-central1-rainmonitor-b0968.cloudfunctions.net/Rain/loginTMA'
          }
          axios.post(url, {
            id: macAddress,
            password: password
          }).then((response)=> {
            firebase.auth().signInWithCustomToken(response.data)
              .then((userCredential) => {
                // Signed in
                db.collection('user').doc(macAddress).set({
                  role:'Petugas',
                  device:macAddress,
                })
                localStorage.setItem("location",this.location)
                localStorage.setItem("uid", userCredential.user.uid);
                localStorage.setItem("device", macAddress);
                localStorage.setItem("role", 'Petugas')
                localStorage.setItem("station", station)
                localStorage.setItem("jenis", jenis)
                loader.hide()
                this.$router.push(`/MapPetugas-id=${macAddress}&device=${jenis}`)
            })
          })
          .catch((error)=> {
            console.log(error)
            console.log(error.response.data);
            this.errorServer=error.response.data
            loader.hide()
          });
         }
      },
      async getStations (location,jenis) {
        console.log(location,jenis)
        if (jenis ==='PCH') {
          await db.collection('device').where('location','==',location).get().then((querySnapshot) => {
            this.stations=[]
            this.station=null
            querySnapshot.forEach((doc) => {
              this.stations.push({value:doc.data().macAddress,text:doc.data().station})
            });
          })
        } else {
          await db.collection('radar').where('location','==',location).get().then((querySnapshot) => {
            this.stations=[]
            this.station=null
            querySnapshot.forEach((doc) => {
              this.stations.push({value:doc.id,text:doc.data().station})
            });
          })
        }
        console.log(this.stations)
      }
    },
  }
</script>
